import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFontSize = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m3 16 4.5-9 4.5 9" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.5 13h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 14h-5" })
	]
});
export default SvgFontSize;
